export default __webpack_public_path__ + "static/media/Renu Malhotra.f09ebe29.jpg";